import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(activity)/transition-lenses-knowledge/components/TransitionTechnologyClient.tsx");
